module.exports = __webpack_public_path__ + "statics/img/erweima.c7e39dc7.png";